<template>
  <div>
    <van-sticky class="searchTitle">
      <Search ref="search" @goSearch="goSearch" @textSearch="textSearch" />
      <ClassType ref="classType" @editActive="editActive" />
    </van-sticky>
    <!-- // 公开课 -->
    <ClassItem
      v-show="active == 1 || active == 2"
      :classList="classList"
      class="m-t-10"
    />
    <!-- 资料 -->
    <Data
      v-show="active == 3"
      :dataList="classList"
      style="padding-left: 20px"
    />
    <NoData
      text="小筑没有搜到相关课程,试试其他关键词把~"
      :empty="empty"
      v-show="noData"
    />
    <div style="height: 50px"></div>
    <Footer></Footer>
  </div>
</template>

<script>
import Search from "@/components/seleClass/search";
import ClassType from "@/components/seleClass/classType";
import Data from "@/components/classification/data"; // 資料
import ClassItem from "@/components/seleClass/classItem";
import Footer from "@/components/footer";

export default {
  components: {
    Search,
    ClassType,
    Data,
    ClassItem,
    Footer,
  },
  data() {
    return {
      empty: require("@/assets/imgs/empty/noLive.png"),
      active: 1,
      classList: [],
      noData: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.getClassList();
    });
  },
  methods: {
    editActive(a) {
      this.active = a;
      this.getClassList();
    },
    getClassList() {
      let data = {
        cname: this.$refs.search.value,
        itid:
          this.$refs.search.$refs.moreSearch.rightActive == ""
            ? 0
            : this.$refs.search.$refs.moreSearch.rightActive,
        itidTwos:
          this.$refs.search.$refs.moreSearch.leftActive.length == 0
            ? [0]
            : this.$refs.search.$refs.moreSearch.leftActive,
        courseContent: this.active,
      };
      this.ApiNew.Class.getCouClass(data).then((res) => {
        if (res.retuCode == 5000) {
          if (res.data.length == 0) {
            this.classList = [];
            this.noData = true;
            return false;
          }
          this.noData = false;
          if (this.active == 3) {
            this.classList = [{ list: [] }];
            this.classList[0].list = res.data;
          } else {
            this.classList = res.data;
          }
        }
      });
    },
    goSearch() {
      this.getClassList();
    },
    textSearch() {
      this.getClassList();
    },
  },
};
</script>


<style lang="less" scoped>
.searchTitle /deep/ .van-sticky--fixed {
    background: white;
  
}
</style>